export default "__VITE_ASSET__8de3af95__"